export default __webpack_public_path__ + "static/media/26_MAXCLAW.f364449c.png";